import axios from "axios";
import { loadTranslations, setLocale } from "react-redux-i18n";
import { momentModule } from "../components/utils/Utils";

import store from "../store";
import { FETCH_LANGUAGES, FETCH_TRANSLATION } from "./types";
import {
  ALLOWED_LANGUAGES,
  LANGUAGE_TRANSLATION,
} from "../styles/utils/constants";
const { moment } = momentModule;

export const setLanguage = (languageCode) => (dispatch) => {
  /* This function is used to change the languages, to the one sent in the 'languageCode' arg, the fetchTranslationV2 
  is protected from unnecessary requests in the following cases:
  - whenever the language already exists (it can be loaded from the local storage so getting the language again is
    wasteful)
  - whenever the translation hash obtained from the customize is the same as the one in the local storage (it means that
  the current translations are up to date) */

  const ReduxStorage = store.getState();
  let languageExist = ReduxStorage.i18n.translations?.[languageCode];

  moment.locale(languageCode);
  dispatch(setLocale(languageCode));

  if (ReduxStorage.account.translationNeedsReload || !!!languageExist) {
    dispatch(fetchTranslationV2(languageCode));
  }
};

export const languageExists = (languageCode) => {
  const ReduxStorage = store.getState();
  let languageExist = ReduxStorage.i18n.translations?.[languageCode];

  return !!!languageExist;
};

export const loadMissingLanguage = (languageCode) => {
  return (dispatch) => {
    if (languageExists(languageCode)) {
      dispatch(fetchTranslationV2(languageCode));
    }
  };
};

export const fetchAllowedLanguagesOnly = () => (dispatch) => {
  /* This function its used to fetch the default allowed languages and then saving in the local storage  */
  axios
    .get(ALLOWED_LANGUAGES)
    .then((res) => {
      if (res.status === 200)
        dispatch({
          type: FETCH_LANGUAGES,
          payload: res.data.languagesAllowed.languages,
        });
    })
    .catch((err) => {
      if (err) console.log(err);
    });
};

export const fetchTranslationV2 = (languageCode) => (dispatch) => {
  /* This function requests and saves in the local storage the requested language from 'languageCode' (arg)  */
  axios
    .get(`${LANGUAGE_TRANSLATION + languageCode}/file?metadata=false`)
    .then((res) => {
      if (res.status === 200) {
        moment.locale(languageCode);
        dispatch(setLocale(languageCode));

        dispatch({
          type: FETCH_TRANSLATION,
          payload: {
            translationHash: res.data.language.translationHash,
            translation: res.data.translation,
          },
        });

        dispatch(
          loadTranslations({
            ...store.getState().i18n.translations,
            [languageCode]: res.data.translation,
          })
        );
      }
    })
    .catch((err) => {
      if (err) console.log(err);
    });
};

export const formatLanguageCode = (code) => {
  if (code) {
    return code.split("_")[0].toUpperCase();
  } else {
    return "";
  }
};
